import { render, staticRenderFns } from "./search-header-desktop.vue?vue&type=template&id=02755115&scoped=true"
import script from "./search-header-desktop.vue?vue&type=script&lang=ts"
export * from "./search-header-desktop.vue?vue&type=script&lang=ts"
import style0 from "./search-header-desktop.vue?vue&type=style&index=0&id=02755115&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02755115",
  null
  
)

export default component.exports